"use client";

import { AnimatePresence, motion } from "framer-motion";
import { useFormatter, useLocale, useTranslations } from "next-intl";
import React, { FC, useContext, useEffect, useState } from "react";
import { Accordion } from "react-accessible-accordion";

import Pagination from "@/components/AvailableUnitsList/Pagination";
import { UserContext } from "@/context/UserContext";
import useMediaQuery from "@/hooks/useMediaQuery";

interface Props {
  unitName?: string;
  serverSideCookieCurrency?: string;
  currencyFromApiRes?: string;
  isBelongToCommunity?: boolean | void;
  matchedCommunity?: any;
}
const UnitsTable: FC<Props> = ({ unitName, serverSideCookieCurrency, currencyFromApiRes, isBelongToCommunity, matchedCommunity }) => {
  const t = useTranslations();
  const format = useFormatter();
  const { currency, measurement } = useContext(UserContext);
  const [preExpanded, setPreExpanded] = useState<string[] | [] | undefined>(undefined);
  const isDesktop = useMediaQuery("(min-width: 1024px)");
  const locale = useLocale();
  const [language, _] = locale.split("-");
  const [isLoadingForPrice, setIsLoadingForPrice] = useState(true);
  const parkingLotNumber = (unitname: string) => {
    const parts = unitname.split("/");
    if (parts.length > 1) {
      return parts[1];
    } else {
      return "";
    }
  };

  const structuredData = false;

  const formatUnitName = (name: string): string => name.replaceAll("/", "-") || name;
  useEffect(() => {
    if (serverSideCookieCurrency && currencyFromApiRes && currency) {
      if (serverSideCookieCurrency === currencyFromApiRes && currencyFromApiRes === currency) {
        setIsLoadingForPrice(false);
      } else {
        setIsLoadingForPrice(true);
      }
    }
  }, [serverSideCookieCurrency, currencyFromApiRes, currency]);
  return (
    <>
      <h2 className="mt-3xl mb-xl text-center text-l md:text-xl uppercase font-primary"></h2>
      {/* {!(filteredResults.length && filteredResults.length === 1) && (
        <>
          {isDesktop && (
            <>
              <DesktopFilters unitTypeName={propertyType} />
              <p className="text-center my-xs md:my-xxl font-secondary text-s font-medium">{t("aul.limited.supply")}</p>
            </>
          )}
        </>
      )} */}
      {preExpanded && (
        <div className="hidden md:block">
          <div className="grid units-grid border-b border-b-gray-10 mb-xs gap-xs md:p-m">
            <div className={`font-secondary font-medium text-s uppercase  ${language === "ar" ? "mr-[100px]" : ""}`}>{t("aul.unitID")}</div>
            <div className={`font-secondary font-medium text-s uppercase  ${language === "ar" ? "mr-[100px]" : ""}`}>{t("aul.unitType")}</div>
            <div className={`font-secondary font-medium text-s uppercase  ${language === "ar" ? "mr-[100px]" : ""}`}>{t("aul.bathrooms")}</div>
            <div className={`font-secondary font-medium text-s uppercase  ${language === "ar" ? "mr-[100px]" : ""}`}>{t("aul.size")}</div>
            <div className={`col-span-2 font-secondary font-medium text-s uppercase ${language === "ar" ? "mr-[100px]" : ""}`}>{t("aul.price")}</div>
          </div>
          <Accordion allowZeroExpanded preExpanded={preExpanded}>
            <AnimatePresence></AnimatePresence>
          </Accordion>
          <Pagination />
        </div>
      )}
      {structuredData && <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }} />}
    </>
  );
};
export default UnitsTable;
